<vi-notification
  class="w-full min-w-full h-full min-h-full"
  data-at-downtime-notification
  icon="info_outline"
  [shadow]="true"
  *ngIf="isGermanUser && isEnabled"
>
  {{ 'DOWNTIME_NOTIFICATION.MESSAGE' | translate }}
</vi-notification>
